import * as moment from "moment";

import { SraCustomerState } from "../sraCustomer";

import { Location } from "redux-little-router";

export interface SraDepartmentListModel {
    readonly sraCustomerId: string;
    readonly id: string;
    readonly name?: string;
    readonly listUpdated?: moment.Moment;
}

export interface SraDepartmentDetailModel {
    readonly sraCustomerId: string;
    readonly id: string;
    readonly name?: string;
    readonly detailUpdated?: moment.Moment;
}

export type SraDepartment = SraDepartmentListModel & SraDepartmentDetailModel;

export interface SraDepartmentCreateModel {
    name: string;
}

export interface SraDepartmentEditModel {
    id: string;
    name: string;
}

export interface SraDepartmentState {
    readonly sraDepartments: SraDepartment[];
    readonly sraDepartment?: SraDepartment;
}

export interface SraDepartmentFilter {
}

export class SraDepartmentBuilder {
    private id: string;
    private name: string;

    constructor() {
        this.name = "Test 1";
    }

    public withId(id: string): SraDepartmentBuilder {
        this.id = id;
        return this;
    }

    public withname(name: string): SraDepartmentBuilder {
        this.name = name;
        return this;
    }

    public build(): SraDepartmentEditModel {
        return {
            id: this.id,
            name: this.name,
        };
    }

}

export type AppState = SraDepartmentState & { router: Location } & SraCustomerState;
